// Mileage Est flagging for UHC SHORT TERM IMPLEMENTATION
// 15% buffer for road distance vs straight line
// TODO: NEW CONSTS FOR CONFIG IN FUTURE
export const MILEAGE_FLAG_THRESHOLD = Object.freeze({
  uhcnm: 100,
  kinetik: 100,
  goridelablue: 100,
  partnership: 300, // Can add more org's mileage threshold here if needed
  cdphe: 35,
});
